(function () {
    'use strict';

    function WZServiceItemV2Controller($scope, $state, SettingInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader) {

        var $ctrl = this;

        loadPage();


        function loadPage(page) {
            translatePartialLoader.addPart('serviceItem');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('company');
            translatePartialLoader.addPart('supplierPanel');
            translatePartialLoader = translate.refresh();

            //

            // if ($ctrl.activityTypeInfo) {
            //     if ($ctrl.activityTypeInfo.servantType == 'RESOURCE') {
            //         $ctrl.serviceItem.itemTitle = $ctrl.activityTypeInfo.serviceSamplePlaceHolder;
            //         $ctrl.serviceItem.minPrice = 0.0;
            //         $ctrl.serviceItem.duration = 60;
            //     } else {
            //         $ctrl.serviceItem.itemTitle =  $ctrl.activityTypeInfo.serviceSamplePlaceHolder;
            //         $ctrl.serviceItem.minPrice = 100000.0;
            //         $ctrl.serviceItem.duration = 60;
            //     }
            // }
            //$ctrl.SettingInfoDtails =  SettingInfoDtailCustom.SettingInfoDtailsByServiceItem($ctrl.serviceItemId).query();
        }


        $scope.$watch('ServiceItemform.$valid', function (isValid) {
            $ctrl.isFormValid(isValid);
        })
    }

    var WZServiceItemV2 = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/wizard-forms-v2/service-item-v2/wizard-form.service-item-v2.html',
        controller: WZServiceItemV2Controller,
        bindings:
            {
                serviceItem: '=?',
                isFormValid: '=?',
                activityTypeInfo: '=?',
                servant: '=?'
            }

    };

    angular
        .module('tikonApp')
        .component('wzfServiceItemV2', WZServiceItemV2)

    WZServiceItemV2Controller.$inject = ['$scope', '$state', 'SettingInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader'];


})();

